import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'

import { ApplicationState } from 'src/store'
import { getAudits } from 'src/core/store/ducks/audits/actions'
import currencyMask from 'src/components/Formik/InputCurrency/mask'
import history from 'src/config/routes/history'
import useDocumentTitle from 'src/hooks/use-document-title'

import * as CSS from '../styles'
import Header from '../components/Header'
import RequestNumberFilter from '../../components/request-number-filter'
import RequestTravelerNameFilter from '../../components/request-traveler-name-filter'
import StatusFilter from '../../components/StatusFilter'
import Table, { DataSource } from '../../components/Table'

export default function Audits() {
  useDocumentTitle('web.side.audits')
  const { audits } = useSelector((state: ApplicationState) => ({
    audits: state.audits
  }))
  const dispatch = useDispatch()

  const [list, setList] = useState<DataSource[]>([])
  const [currentPage, setCurrentPage] = useState<number>(1)

  useEffect(() => {
    dispatch(getAudits({ filterStatus: audits.filterStatus, page: 1 }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    setList(
      audits.list.map(
        ({
          cost,
          empowered_users,
          request_id,
          request_number,
          request_user_data,
          requested_on,
          status,
          sync_status,
          title
        }) => ({
          cost: currencyMask({
            formatStr: true,
            value: cost
          }).maskedValue,
          id: request_id,
          empowered_users,
          number: request_number,
          key: request_id,
          title,
          startDate: moment.unix(requested_on).format('DD/MM/YYYY'),
          status,
          sync_status,
          users: request_user_data.map(
            ({ reason, status, traveler: { gender, name, user_id } }) => ({
              gender,
              name,
              reason,
              status,
              user_id
            })
          )
        })
      )
    )
  }, [audits.list])

  return (
    <>
      <Header error={audits.error} title="web.side.audits" />
      <CSS.HeaderFilters>
        <RequestNumberFilter
          initialValues={audits.filterRequestNumber}
          onChange={values => {
            dispatch(getAudits({ request_numbers: values, page: 1 }))
            setCurrentPage(1)
          }}
        />
        <RequestTravelerNameFilter
          initialValues={audits.filterRequestTravelerName}
          onChange={values => {
            dispatch(getAudits({ traveler_name: values, page: 1 }))
            setCurrentPage(1)
          }}
        />
        <StatusFilter
          defaultValue={audits.filterStatus}
          onChange={values => {
            dispatch(getAudits({ filterStatus: values, page: 1 }))
            setCurrentPage(1)
          }}
          options={[
            'approval_pending',
            'approval_reproved',
            'conference_pending',
            'closing_pending',
            'underway',
            'conference_reproved',
            'closing_reproved',
            'finished',
            'canceled'
          ]}
        />
      </CSS.HeaderFilters>
      <Table
        currentPage={currentPage}
        dataSource={list}
        loading={audits.loading}
        myRequests
        onChange={page => {
          dispatch(getAudits({ filterStatus: audits.filterStatus, page }))
          setCurrentPage(page)
        }}
        onRow={(record: DataSource) => ({
          onClick: () => {
            history.push(`/audits/${record.id}/summary/`)
          }
        })}
        totalPages={audits.total_results}
      />
    </>
  )
}
